import type { ReviewClosingRow } from '../types'

/**
 * Totais da Revisão. São outros números que os de `totals`: aqui o frete fica de fora, porque quem
 * soma o pedido inteiro é o resumo do Frete (§7.1 da spec).
 */
export interface ReviewTotals {
  count: number
  pieces: number
  registeredTotal: number
  effectiveTotal: number
  eligibleForRateio: number
}

export const computeReviewTotals = (rows: ReviewClosingRow[]): ReviewTotals => ({
  count: rows.length,
  pieces: rows.reduce((acc, row) => acc + (row.pieces ?? 0), 0),
  registeredTotal: rows.reduce((acc, row) => acc + row.registeredPrice, 0),
  effectiveTotal: rows.reduce((acc, row) => acc + (row.sellingPrice ?? row.registeredPrice), 0),
  eligibleForRateio: rows.filter((row) => row.registeredPrice > 0).length,
})

export const formatCurrency = (value: number): string =>
  value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
